var map = {
	"./screen1.jpg": 52,
	"./screen2.jpg": 53,
	"./screen3.jpg": 54,
	"./screen4.jpg": 55,
	"./screen5.jpg": 56,
	"./screen6.jpg": 57,
	"./screen7.jpg": 58
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 51;